import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
import ReactGA4 from "react-ga4";
import { useCallback, useEffect } from "react";
import consola from "consola";

let initializedReactGa = false;

const useGoogleAnalytics = () => {
  const location = useLocation();
  const config = useSelector((state) => state.config);
  const optanon = useSelector((state) => state.optanon);

  const initGA = useCallback(() => {
    // const ga_id = "UA-000000-01"; // for testing only
    const { ga_id } = config;

    ReactGA4.initialize(process.env.REACT_APP_MEASUREMENT_ID);
    initializedReactGa = true;

    if (!ga_id) {
      consola.warn("Could not initialize GA as GA ID is missing");
      return;
    }

    consola.info("Initialized GA with following GA ID", ga_id);
    ReactGA.initialize(ga_id);
  }, [config]);

  const isConsentent = useCallback(() => {
    return optanon.activeGroups.includes(1);
  }, [optanon.activeGroups]);

  // Debug purpose only but useful in production too
  useEffect(() => {
    consola.info("Notified of consent update");

    if (!isConsentent()) {
      consola.warn("User did not consent to the use of GA");
      return;
    }

    consola.success("User consented to the use of GA");
  }, [optanon, isConsentent]);

  useEffect(() => {
    if (initializedReactGa || !config || !isConsentent()) {
      return;
    }

    initGA();
  }, [config, optanon, isConsentent, initGA]);

  useEffect(() => {
    if (!isConsentent()) {
      return;
    }

    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactGA4.send({ hitType: "pageview", page: window.location.pathname + window.location.search, title: window.location.pathname });
  }, [location, isConsentent]);
};

export default useGoogleAnalytics;
